import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import AddVisualStateForm from '../../AddVisualStateForm/AddVisualStateForm';
import getJsonSummary from '../../../../../services/mini/getJsonSummary';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import getConversationId from '../../../../../services/mini/getConversationId';

class VisualStateTestModeBubble extends React.Component {

    editVisualState = () => {
        const { data } = this.props;
        const { visualState } = data;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <AddVisualStateForm
                        visualState={visualState}
                        onClose={onClose}
                        closeLabel="Close"
                        saveLabel="Apply Changes"
                        onSave={(visualState) => {
                            const { updateVisualState, dialogTree, node, conversationId } = this.props;
                            updateVisualState({
                                dialogTree,
                                visualState,
                                curNode: node,
                                conversationId
                            });
                        }}
                    />
                );
            }
        });
    }

    render() {
        const { data } = this.props;

        return (
            <div className="visual-state" onClick={this.editVisualState}>
                {getJsonSummary(data.visualState)}
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }) {
    return {
        dialogs: testMode.dialogs,
        dialogTree: testMode.dialogTree,
        conversationId: getConversationId(projectsInfo.currentProject.conversations)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        updateVisualState: (param) => asyncDispatch(actions.updateVisualState, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualStateTestModeBubble);

